<script lang="ts" setup>
export interface Props {
  editable?: boolean
}

withDefaults(defineProps<Props>(), { editable: false })

const { total } = useCart()
const { totalQuantity } = useAddToCart()
</script>

<template>
  <div class="mini-cart">
    <appLink
      type="button"
      class="mini-cart__link"
      :aria-label="$t('Basket')"
      to="/cart"
    >
      <Icon
        name="icon:shoppingcart"
        class="mini-cart__icon icon icon--shoppingcart"
      />
      <span
        class="mini-cart__amount"
        v-text="totalQuantity ? totalQuantity : '0'"
      />
      <span
        class="mini-cart__label"
        v-text="$t('Basket')"
      />
      <span
        class="mini-cart__price"
        v-text="total"
      />
    </appLink>
  </div>
</template>

<style>
@import url("~layers/app/components/Cart/MiniCart.css");
</style>
